<div *ngIf="orderSummary" class="basket">
  <div
    *ngIf="
      journeyType === JourneyType.MobileVip && orderSummary.numFreePayments
    "
    class="mb-6"
  >
    Sky Mobile 1-month free cover - then
    {{ orderSummary.totalAmount | currency: 'GBP' }} a month
  </div>
  <div class="basket__title mb-6 typog-h2">
    {{ getSkyBoxName(orderSummary.skyBoxName) }}
  </div>

  <div
    class="typog-h3 mb-6 basket__included_devices"
    *ngIf="
      journeyType !== JourneyType.Mobile &&
      journeyType !== JourneyType.MobileVip
    "
  >
    Included devices
  </div>

  <ng-container *ngFor="let device of orderSummary.includedDevices">
    <sky-ui-order-summary-item
      *ngIf="isSkyBox(device); else includedDevice"
      (remove)="removeSkyBox.emit()"
      [device]="device"
      [readOnly]="readOnly"
      [allowEdit]="false"
    >
    </sky-ui-order-summary-item>

    <ng-template #includedDevice>
      <sky-ui-order-summary-item
        (remove)="handleRemove($event, true)"
        [device]="device"
        [readOnly]="readOnly"
      >
      </sky-ui-order-summary-item>
    </ng-template>
  </ng-container>

  <ng-container *ngIf="orderSummary.additionalDevices?.length">
    <div class="typog-h3 mb-4">Additional Devices</div>

    <sky-ui-order-summary-item
      *ngFor="let device of orderSummary.additionalDevices"
      (remove)="handleRemove($event)"
      [device]="device"
      [readOnly]="readOnly"
    >
    </sky-ui-order-summary-item>
  </ng-container>

  <div
    *ngIf="orderSummary.additionalDevices?.length"
    class="basket__total typog-body-large-bold py-6"
  >
    <div
      *ngIf="orderSummary.numFreePayments"
      class="flex justify--space-between mb-6"
    >
      <div>Included devices</div>

      <div class="xs--flex-column align--end">
        <div>Sky VIP {{ orderSummary.numFreePayments }}-month free cover</div>
      </div>
    </div>

    <div class="flex justify--space-between">
      <div>Additional devices</div>

      <div class="xs--flex-column align--end">
        <div>
          {{ getAdditionalDevicesValue(orderSummary) | currency: 'GBP' }}
        </div>
      </div>
    </div>
  </div>

  <div class="basket__total pt-6 mb-4">
    <div class="flex justify--space-between">
      <div class="typog-h3">Total</div>

      <div class="xs--flex-column align--end">
        <div class="typog-h3">
          {{
            (orderSummary.numFreePayments
              ? getAdditionalDevicesValue(orderSummary)
              : orderSummary.totalAmount
            ) | currency: 'GBP'
          }}
        </div>
        <div class="sub-price">per month</div>
      </div>
    </div>
    <div *ngIf="orderSummary.numFreePayments" class="text--right">
      <div
        *ngIf="orderSummary.additionalDevices?.length; else normalPayment"
        class="mt-4"
      >
        <p>
          for the first
          {{
            orderSummary.numFreePayments === 1
              ? 'month'
              : orderSummary.numFreePayments + ' months'
          }}
        </p>
      </div>

      <ng-template #normalPayment>
        <p>
          for the first
          {{
            orderSummary.numFreePayments === 1
              ? 'month'
              : orderSummary.numFreePayments + ' months'
          }}
        </p>
      </ng-template>

      <p class="mt-6">
        From the {{ getFollowingMonth(orderSummary.numFreePayments) }} month you
        will be paying
        <strong style="font-size: 26px">{{
          orderSummary.totalAmount | currency: 'GBP'
        }}</strong>
        a month
      </p>
    </div>
  </div>
</div>
